import { HttpErrorResponse } from '@angular/common/http'
import { computed, Injectable, signal } from '@angular/core'

import { StatsService } from '../stats.service'
import { isEmpty, omitBy } from 'lodash'
import { StatsSearchParams } from '../models/stats-search.model'
import { Stats } from '../models/stats.entity'

interface StatsListingState {
  params?: StatsSearchParams
  stats?: Partial<Stats>
  isLoading: boolean
  error?: HttpErrorResponse
}

const STATS_INITIAL_STATE: StatsListingState = {
  isLoading: false,
}

@Injectable()
export class StatsListingStore {
  constructor(private statsService: StatsService) {}

  private state = signal<StatsListingState>(STATS_INITIAL_STATE)

  // Selectors

  readonly stats = computed(() => this.state().stats)
  readonly isLoading = computed(() => this.state().isLoading)

  // Effects

  async search(params: StatsSearchParams): Promise<void> {
    this.unsetError()

    return new Promise((resolve, reject) => {
      this.statsService.stats$(params).subscribe({
        next: (data) => {
          this.setData(data, params)
          resolve()
        },
        error: (error) => {
          this.setError(error)
          reject(error)
        },
      })
    })
  }

  // Reducers

  setData(stats: Stats, params: StatsSearchParams) {
    this.state.set({
      ...this.state(),
      stats: omitBy<Stats>(stats, isEmpty),
      params,
      isLoading: false,
      error: undefined,
    })
  }

  setIsLoading(isLoading: boolean) {
    this.state.set({ ...this.state(), isLoading })
  }

  setError(error: HttpErrorResponse) {
    this.state.set({ ...this.state(), isLoading: false, error })
  }

  unsetError() {
    this.state.set({ ...this.state(), isLoading: true, error: undefined })
  }
}
